import React from 'react';
import MainLayout from '../components/layout/MainLayout';
import About from '../components/about/About';

const AboutPage = () => {
  return (
    <div>
      <MainLayout>
        <About />
      </MainLayout>
    </div>
  )
}

export default AboutPage
